<template>
  <div ref="home">
    <b-modal @hidden="verifyModal"
             id="modal-prevent-closing" centered :title="$t('inputCode')">
      <b-input v-model="code" v-on:keyup.enter="verifyCode"></b-input>
      <template #modal-footer>

        <b-button variant="light" class="colorBtn" v-on:click="verifyCode"
        >
          {{ $t('btnVerify') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import apiService from "../service/service";
import app from "../firebaseConfig/config";
import Cryptr from 'crypto-js'

export default {
  name: 'Home',
  data() {
    return {
      code: 'barcelona_time_use',
      isModalVerified: false,
      company: "Barcelona Time Use"
    }
  },
  computed: {
    ...mapState(['footerClass', 'role'])
  },
  methods: {

    showModal() {
      this.$bvModal.show('modal-prevent-closing')
    },
    hideModal() {
      this.$bvModal.hide('modal-prevent-closing')
    },
    async verifyCode() {
      if (this.code) {
        const data = {code: this.code, email: this.getCookie('email'), company: this.company}
        this.$bvToast.toast(this.$i18n.t('toastedMessageVerifyCode').toString(), {
          variant: 'warning',
          solid: true
        })

        try {
          const accessToken = await app.auth().currentUser.getIdToken(true)
          const response = await apiService.verifyPromotionalCode(data, accessToken)
          this.setCookie('isChat', response.data.event.isChatActive.toString(), true)
          this.$store.commit('updateIsChatActivated', response.data.event.isChatActive)
          if (!response.data.verified) {
            this.$bvToast.toast(this.$i18n.t('errorMessageInvalidPromotionalCode').toString(), {
              title: 'Error',
              variant: 'danger',
              solid: true
            })
          } else {
            try {
              const user = await app.auth().currentUser
              if (user) localStorage.clear()
            } catch (e) {
              this.$bvToast.toast(this.$i18n.t('errorMessageInvalidPromotionalCode').toString(), {
                title: 'Error',
                variant: 'danger',
                solid: true
              })
              console.log(e)
            }
            if (this.role === 'secretary') {
              localStorage.setItem('eventQuestionsEn', JSON.stringify(response.data.event.questionsEn))
              localStorage.setItem('eventQuestionsEs', JSON.stringify(response.data.event.questionsEs))
              localStorage.setItem('eventQuestionsCat', JSON.stringify(response.data.event.questionsCat))
              this.setCookie('eventId', response.data.event.id, true)
            }
            localStorage.setItem("webinarTitleEn", response.data.event.titleEn)
            localStorage.setItem("webinarTitleEs", response.data.event.titleEs)
            localStorage.setItem("webinarTitleCat", response.data.event.titleCat)
            localStorage.setItem("webinarSubTitleEs", response.data.event.subTitleEs)
            localStorage.setItem("webinarSubTitle", response.data.event.subTitleEn)
            localStorage.setItem("webinarSubTitle", response.data.event.subTitleCat)
            localStorage.setItem('playerUrlEn', response.data.event.playerUrlEn)
            localStorage.setItem('playerUrlEs', response.data.event.playerUrlEs)
            localStorage.setItem('playerUrlCat', response.data.event.playerUrlCat)
            localStorage.setItem('numQuestions', response.data.event.questionsEn.length.toString())
            localStorage.setItem('areQuestionsActive', response.data.event.areQuestionsActive)
            localStorage.setItem('eventCode', response.data.event.code)
            localStorage.setItem('posterStartEn', response.data.event.posterStartEn)
            localStorage.setItem('posterStartEs', response.data.event.posterStartEs)
            localStorage.setItem('posterStartCat', response.data.event.posterStartCat)
            localStorage.setItem('posterEndEn', response.data.event.posterEndEn)
            localStorage.setItem('posterEndEs', response.data.event.posterEndEs)
            localStorage.setItem('posterEndCat', response.data.event.posterEndCat)
            localStorage.setItem('panicPoster', response.data.event.panicPoster)
            this.setCookie('code', this.code, false)

            this.$bvToast.toast(this.$i18n.t('successMessageVerifiedCode').toString(), {
              variant: 'success',
              solid: true
            })
            this.isModalVerified = true
            this.hideModal()
            this.$emit('goPlayer', this.code)
          }
        } catch (e) {
          console.log(e)
          this.$bvToast.toast(this.$i18n.t('errorMessageInvalidPromotionalCode').toString(), {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
        }
      } else {
        this.$bvToast.toast(this.$i18n.t('errorMessageInvalidPromotionalCode').toString(), {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
    },
    verifyModal() {
      this.isModalVerified ? this.hideModal() : this.showModal()
    },
    deleteCookie(name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
    getCookie(cname) {
      const name = cname + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    setCookie(cookieName, cookieValue, encrypted) {
      const now = new Date()
      const time = now.getTime()
      const expireTime = time + 1000 * 36000
      now.setTime(expireTime)
      encrypted ? document.cookie = cookieName + "=" + Cryptr.AES.encrypt(cookieValue, 'secret key 1234').toString() + "; expires=" + now.toUTCString() : document.cookie = cookieName + "=" + cookieValue + "; expires=" + now.toUTCString()
    },
  },
  mounted() {
    this.verifyCode()
    //this.showModal()
  },
}
</script>
<style scoped>
img {
  width: 1px;
}
.colorBtn {
  background-color: #39bac1;
}
</style>
